import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  adaptErrorToGenericResponse,
  adaptFileToGenericResponse,
} from '../shared';

import type { ReportRequest } from './models';
import { mapReportRequestToDto } from './mappers';

export const getReport = async (
  body: ReportRequest,
): Promise<GenericResponse<ArrayBuffer>> => {
  try {
    const dto = mapReportRequestToDto(body);
    const response = await wtClientApi.post<ArrayBuffer>('/report', dto, {
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Cache-Control': 'no-cache',
      },
      responseType: 'arraybuffer',
    });

    return adaptFileToGenericResponse(
      response.data,
      response.status,
      response.headers,
    );
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al descargar el archivo',
    );
  }
};
